import DailyForecast from "./DailyForecast"

export default DailyForecast
